import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';
import MobileStepper from '@material-ui/core/MobileStepper';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import GetPeriodPlanResultQuery from '../../common/graphql/GetPeriodPlanResult';
import Divider from '@material-ui/core/Divider';
import { UPDATE_PPR_FEEDBACK } from '../../common/graphql/UpdatePprFeedback';
import { UPDATE_PERIOD_PLAN_RESULT } from '../../common/graphql/UpdatePeriodPlanResult';
import Button from '../../components/Button';
import { useQuery, useMutation } from 'react-apollo-hooks';
import Result from '../ResultsProgress/Result';
import get from 'lodash/get';
import UserContext from '../../contexts/UserContext';
import { useSnackbar } from 'notistack';
import format from 'date-fns/format';
import { MemberDetailsContext } from '../../views/DashboardPage/MyTeamPage/MemberDetails';
import Promise from 'bluebird';

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const styles = theme => ({
  root: {
    display: 'grid',
  },
  result: {
    overflow: 'hidden',
    height: 190,
    marginLeft: 55,
  },
  comment: {
    marginTop: 20,
  },
  button: {
    justifySelf: 'end',
    marginTop: 20,
  },
  memberPlan: {
    textAlign: 'center',
    padding: 10,
    '& > p': {
      padding: 20,
    },
  },
});

const FeedbackForm = ({ classes, planResultId: periodPlanResultId }) => {
  const dateFormat = 'yyyy-MM-dd';
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const { currentUser } = React.useContext(UserContext);
  const [autoScroll, setAutoScroll] = React.useState(true);
  const [updating, setUpdating] = React.useState(false);
  const [currentStep, setCurrentStep] = React.useState(0);
  const [ppr, setPpr] = React.useState(null);
  const [feedback, setFeedback] = React.useState('');
  const [date, setDate] = React.useState(null);

  const [mbrDetailState] = React.useContext(MemberDetailsContext);
  const swipeableActions = mbrDetailState.get('swipeableActions');
  const member = mbrDetailState.get('member');
  console.log('>>FeedbackForm/index::', 'member', member); //TRACE
  console.log('>>FeedbackForm/index::', 'periodPlanResultId', periodPlanResultId); //TRACE
  const { data, loading, refetch } = useQuery(GetPeriodPlanResultQuery().query, {
    variables: {
      periodPlanResultId,
    },
    fetchPolicy: 'network-only',
  });
  React.useLayoutEffect(() => {
    if (!swipeableActions) return;
    Promise.delay(1500).then(() => {
      swipeableActions.updateHeight();
    });
  }, [data, swipeableActions, loading]);

  const updateFeedback = useMutation(UPDATE_PERIOD_PLAN_RESULT.mutation, {
    variables: {
      input: {
        id: periodPlanResultId,
        alerts: ['/coach-corner'],
        managerFeedback: {
          commenter: currentUser.username,
          body: feedback,
          date: format(new Date(), dateFormat),
        },
      },
    },
  });

  React.useEffect(() => {
    console.log('DATA IN FORM: ', data);
    if (data) setPpr(data.getPeriodPlanResult);
  }, [data]);

  React.useEffect(() => {
    console.log('DATA IN FORM: ', data);
    if (ppr) {
      setDate(get(ppr, 'managerFeedback.date'));
      setFeedback(get(ppr, 'managerFeedback.body'));
    }
  }, [ppr]);

  if (loading) return 'Loading..';

  return (
    <div className={classes.root}>
      <Paper className={classes.memberPlan} elevation={2}>
        <Typography variant="h6" component="h4">
          <strong>{get(member, 'firstName', '')}</strong>'s Plan for{' '}
          <strong>{get(ppr, 'period.name')}</strong>
        </Typography>
        <Typography component="p">"{get(ppr, 'plan', '')}"</Typography>
      </Paper>
      <Divider style={{ marginTop: 20, marginBottom: 20 }} />
      <Typography>
        Performance for <strong>{get(ppr, 'period.name')}</strong>
      </Typography>
      <AutoPlaySwipeableViews
        autoplay={autoScroll}
        index={currentStep}
        onChangeIndex={step => setCurrentStep(step)}
        onClick={() => setAutoScroll(false)}
        interval={5000}
        enableMouseEvents
      >
        <div className={classes.result}>
          <Result
            label="GP$"
            prefix="$"
            actual={get(ppr, 'actualWeeklyGp')}
            target={get(ppr, 'targetWeeklyGp')}
          />
        </div>
        <div className={classes.result}>
          <Result
            label="Hourly Customers"
            actual={get(ppr, 'actualHourLyCustomers')}
            target={get(ppr, 'targetHourLyCustomers')}
          />
        </div>
        <div className={classes.result}>
          <Result
            label="UPT"
            actual={get(ppr, 'actualWeeklyUpt')}
            target={get(ppr, 'targetWeeklyUpt')}
          />
        </div>
      </AutoPlaySwipeableViews>
      <MobileStepper
        nextButton={
          <IconButton
            size="small"
            onClick={() => {
              setCurrentStep(prevStep => (prevStep === 2 ? 0 : prevStep + 1));
              setAutoScroll(false);
            }}
          >
            <KeyboardArrowRight />
          </IconButton>
        }
        backButton={
          <IconButton
            size="small"
            onClick={() => {
              setCurrentStep(prevStep => (prevStep === 0 ? 2 : prevStep - 1));
              setAutoScroll(false);
            }}
          >
            <KeyboardArrowLeft />
          </IconButton>
        }
        steps={3}
        position="static"
        activeStep={currentStep}
      />
      <TextField
        helperText={date && `Last updated ${date}`}
        className={classes.comment}
        value={feedback}
        onChange={e => setFeedback(e.target.value)}
        variant="outlined"
        multiline
        rows={4}
        label="Give some feedback"
        placeholder="e.g. Good job overall! Let's focus on customer relation next week."
        disabled={updating}
      />
      <Button
        onClick={async () => {
          setUpdating(true);
          if (!periodPlanResultId) {
            enqueueSnackbar(
              'No period plan result found for selected period. Create one before giving feedback',
              { variant: 'error' },
            );
          } else {
            try {
              await updateFeedback();
              refetch();
              setDate(format(new Date(), dateFormat));
              enqueueSnackbar('Feedback submitted!', { variant: 'success' });
            } catch (e) {
              console.error('FEEDBACK FORM ERROR: ', e);
              enqueueSnackbar('Something went wrong. Please refresh and try again', {
                variant: 'error',
              });
            } finally {
              setUpdating(false);
            }
          }
        }}
        disabled={updating}
        size="large"
        color="primary"
        classes={{ root: classes.button }}
      >
        Submit feedback
      </Button>
    </div>
  );
};

export default withStyles(styles)(FeedbackForm);
